import {
  FirestoreCollectionProsessorOptions,
  createFirestoreCollectionProsessor,
} from "../firebase/firestore";

/**
 * TADS の被参照情報。中身と docID 形式(`{versionId}:{sheetId}`)は通常シートの
 * `ReferredFrom` と同じ。物理削除 API はこれが 1 件でも残っていると
 * 409 (`TAD_SHEET_IS_STILL_REFERRED`) でブロックする。
 */
export type TadSheetReferredFrom = {
  id: string;
  versionId: string;
  sheetId: string;
};

type TadSheetReferredFromRaw = {
  id: string;
  version_id: string;
  sheet_id: string;
};

export const buildTadSheetReferredFromId = (
  versionId: string,
  sheetId: string
) => `${versionId}:${sheetId}`;

const processorOptions: FirestoreCollectionProsessorOptions<
  TadSheetReferredFrom,
  TadSheetReferredFromRaw,
  Record<"tadSheetId", string>
> = {
  getCollectionPath: ({ organizationId, tadSheetId }) =>
    `/app/spreadsheet_ui/v/1/organizations/${organizationId}/tad_sheets/${tadSheetId}/referred_from`,
  toFirestore: ({ id, versionId, sheetId }) => ({
    id,
    version_id: versionId,
    sheet_id: sheetId,
  }),
  fromFirestore: ({ id, version_id, sheet_id }) => ({
    id,
    versionId: version_id,
    sheetId: sheet_id,
  }),
};

export const {
  useGet: useGetTadSheetReferredFrom,
  useGetAll: useGetTadSheetReferredFroms,
  useSet: useSetTadSheetReferredFrom,
  useDelete: useDeleteTadSheetReferredFrom,
  useItems: useTadSheetReferredFroms,
} = createFirestoreCollectionProsessor(processorOptions);
